import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Typography,
} from "@material-ui/core"
import { useSnackbar } from "../../../utils/notificacoes"
import { useEffect, useState } from "react"

import { ObterImagens } from "../../../services/cardapio"

/**
 * Modal "Escolher foto": mostra as fotos ja enviadas na pasta do estabelecimento (S3)
 * e permite reaproveitar uma delas. Ao clicar numa foto, chama onSelect(url).
 * A EXCLUSÃO de fotos fica apenas na tela Galeria (aberta pela tela inicial).
 */
export default function DialogGaleriaFotos({ open, onClose, onSelect, idEstabelecimento }) {
    const { enqueueSnackbar } = useSnackbar()
    const [imagens, setImagens] = useState([])
    const [carregando, setCarregando] = useState(false)

    useEffect(() => {
        if (!open || !idEstabelecimento) return

        let ativo = true
        const carregar = async () => {
            setCarregando(true)
            try {
                const autorizacao = localStorage.getItem("chaveSistema")
                const resp = await ObterImagens(idEstabelecimento, autorizacao)
                if (!ativo) return

                if (resp?.retornoErro) {
                    enqueueSnackbar(resp.mensagem || "Não foi possível carregar as fotos.", {
                        variant: "error",
                    })
                    setImagens([])
                } else {
                    const urls = (Array.isArray(resp) ? resp : [])
                        .map(i => (typeof i === "string" ? i : i?.valor))
                        .filter(Boolean)
                    setImagens(urls)
                }
            } catch (error) {
                if (ativo) {
                    enqueueSnackbar("Erro ao carregar as fotos.", { variant: "error" })
                    setImagens([])
                }
            } finally {
                if (ativo) setCarregando(false)
            }
        }

        carregar()
        return () => {
            ativo = false
        }
    }, [open, idEstabelecimento])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Escolher foto</DialogTitle>
            <DialogContent dividers>
                {carregando ? (
                    <Grid container justifyContent="center" style={{ padding: 24 }}>
                        <CircularProgress />
                    </Grid>
                ) : imagens.length === 0 ? (
                    <Typography color="textSecondary" style={{ padding: 12 }}>
                        Nenhuma foto enviada ainda nesta operação.
                    </Typography>
                ) : (
                    <Grid container spacing={1}>
                        {imagens.map((url, idx) => (
                            <Grid item xs={4} sm={3} md={2} key={idx}>
                                <img
                                    src={url}
                                    alt=""
                                    loading="lazy"
                                    onClick={() => onSelect(url)}
                                    style={{
                                        width: "100%",
                                        height: 90,
                                        objectFit: "cover",
                                        borderRadius: 6,
                                        cursor: "pointer",
                                        border: "2px solid transparent",
                                    }}
                                    onMouseOver={e => (e.currentTarget.style.borderColor = "#4e73df")}
                                    onMouseOut={e =>
                                        (e.currentTarget.style.borderColor = "transparent")
                                    }
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}
